// THIS FILE IS AUTO GENERATED - do not edit!

import { forwardRef, type JSX } from 'react';

import { SvgIcon, type SvgIconProps } from '../lib/SvgIcon.js';

const PlayIconComponent = /* @__PURE__ */ forwardRef<
  SVGSVGElement,
  SvgIconProps
>((props: SvgIconProps, forwardedRef): JSX.Element => {
  return (
    <SvgIcon data-iconname="PlayIcon" ref={forwardedRef} {...props}>
      <path d="M17 10 5 3v14zm-2.977 0L6.5 14.388V5.612z" />
    </SvgIcon>
  );
});

/**
 * @public
 */
export const PlayIcon = /* @__PURE__ */ Object.assign(PlayIconComponent, {
  displayName: 'PlayIcon',
});
